import { render, staticRenderFns } from "./FeaturedStatistics.vue?vue&type=template&id=8fa0fd0e&"
import script from "./FeaturedStatistics.vue?vue&type=script&lang=js&"
export * from "./FeaturedStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports